import React, { useState } from 'react';

// const API_URL = process.env.REACT_APP_API_URL || 'https://vikash-portfolio-backend.onrender.com/api';

const INPUTS = [
  { name: 'name', label: 'Your Name', type: 'text', placeholder: 'John Doe' },
  { name: 'email', label: 'Email', type: 'email', placeholder: 'you@company.com' },
  { name: 'subject', label: 'Subject', type: 'text', placeholder: 'Opportunity / Collaboration' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [errMsg, setErrMsg] = useState('');

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus('sending');
  setErrMsg('');
  try {
    const res = await fetch('https://formspree.io/f/xeewavpw', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setStatus('idle'), 5000);
    } else {
      setErrMsg('Something went wrong. Try emailing directly.');
      setStatus('error');
    }
  } catch (err) {
    setErrMsg('Could not send. Try emailing directly.');
    setStatus('error');
  }
};

  const inputStyle = {
    background: 'var(--bg)',
    border: '1.5px solid var(--border-color)',
    borderRadius: 12,
    padding: '0.85rem 1rem',
    fontSize: '0.9rem',
    fontFamily: "'Syne', sans-serif",
    color: 'var(--text-primary)',
    width: '100%',
    outline: 'none',
    transition: 'border-color 0.2s, background 0.2s',
  };

  return (
    <section id="contact" style={{ background: 'transparent' }}>
      <div className="inn">
        <div className="reveal">
          <div className="contact-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'start' }}>
            
            {/* Left Column: Let's Build Together Headline & Cards */}
            <div>
              <div className="ccbig">LET'S<br />BUILD<br />TOGETHER</div>
              <p className="cctag">Open to Full Stack, Backend &amp; AI/ML roles.<br />Full-time · Freelance · Remote- your call.</p>
              
              <div className="cccards">
                <a href="mailto:gautam7.ven@gmail.com" className="cccard">
<div className="cccard-ic">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>
</div>                  gautam7.ven@gmail.com
                  <div className="cccard-lb">Email</div>
                </a>
                <a href="tel:+919307231784" className="cccard">
<div className="cccard-ic">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 012 2a2 2 0 011.72-2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
</div>                  +91 93072 31784
                  <div className="cccard-lb">Phone</div>
                </a>
                <a href="https://github.com/vikash1311" className="cccard" target="_blank" rel="noreferrer">
<div className="cccard-ic">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/></svg>
</div>                  vikash1311
                  <div className="cccard-lb">GitHub</div>
                </a>
                <a href="https://linkedin.com/in/vikash2808" className="cccard" target="_blank" rel="noreferrer">
<div className="cccard-ic">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
</div>                  vikash2808
                  <div className="cccard-lb">LinkedIn</div>
                </a>
              </div>

              <div style={{ fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '2.5px', color: 'var(--accent-color)', textTransform: 'uppercase' }}>
                Nagpur, India · Open to Relocation &amp; Remote
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
              {INPUTS.map(inp => (
                <div key={inp.name} style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                  <label style={{ fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-muted)' }}>{inp.label}</label>
                  <input name={inp.name} type={inp.type} placeholder={inp.placeholder} required={inp.name !== 'subject'}
                    value={form[inp.name]} onChange={handleChange} style={inputStyle}
                    onFocus={e => { e.target.style.borderColor = 'var(--accent-color)'; e.target.style.background = 'var(--card-bg)'; }}
                    onBlur={e => { e.target.style.borderColor = 'var(--border-color)'; e.target.style.background = 'var(--bg)'; }} />
                </div>
              ))}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                <label style={{ fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-muted)' }}>Message</label>
                <textarea name="message" placeholder="Tell me about your project or role..." required
                  value={form.message} onChange={handleChange}
                  style={{ ...inputStyle, resize: 'vertical', minHeight: 120 }}
                  onFocus={e => { e.target.style.borderColor = 'var(--accent-color)'; e.target.style.background = 'var(--card-bg)'; }}
                  onBlur={e => { e.target.style.borderColor = 'var(--border-color)'; e.target.style.background = 'var(--bg)'; }} />
              </div>

              {status === 'error' && (
                <div style={{ background: 'var(--accent3-glow)', border: '1px solid var(--border-color)', borderRadius: 10, padding: '0.75rem 1rem', fontSize: '0.85rem', color: 'var(--accent3-color)' }}>
                  ⚠️ {errMsg}
                  <div style={{ marginTop: '0.5rem' }}>
                    <a href={`mailto:gautam7.ven@gmail.com?subject=${encodeURIComponent(form.subject||'Portfolio enquiry')}&body=${encodeURIComponent(form.message)}`}
                      style={{ color: 'var(--accent3-color)', fontWeight: 700, fontSize: '0.82rem' }}>📧 Email directly instead →</a>
                  </div>
                </div>
              )}
              {status === 'success' && (
                <div style={{ background: 'var(--accent-glow)', border: '1px solid var(--border-color)', borderRadius: 10, padding: '0.75rem 1rem', fontSize: '0.85rem', color: 'var(--accent-color)' }}>✅ Message sent! I'll reply within 24–48 hours.</div>
              )}

              <button type="submit" disabled={status === 'sending'}
                style={{ background: status === 'success' ? 'var(--green)' : status === 'sending' ? 'var(--text-muted)' : 'var(--accent-color)', color: '#fff', border: 'none', borderRadius: 100, padding: '1rem 2rem', fontSize: '0.9rem', fontWeight: 700, fontFamily: "'Syne', sans-serif", cursor: status === 'sending' ? 'wait' : 'none', letterSpacing: '0.03em', transition: 'background 0.2s, transform 0.2s', alignSelf: 'flex-start' }}
                onMouseEnter={e => { if (status === 'idle') e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => e.currentTarget.style.transform = ''}>
                {status === 'sending' ? 'Sending...' : status === 'success' ? '✓ Sent!' : 'Send Message →'}
              </button>
            </form>
            
          </div>
        </div>
      </div>
      
      <style>{`
        @media(max-width:768px){
          #contact { padding: 0 1rem 4rem !important; }
          #contact > div { padding: 2rem 1.5rem !important; }
          .contact-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
        }
      `}</style>
    </section>
  );
}